module.exports = __webpack_public_path__ + "img/a4-spreadsheet.9d0a3d2b.png";